





















import Vue from 'vue';
import WorldMap from '@components/old-components/amex-map.vue';
import {useMap} from './regions-map';
import VueCompositionAPI, {defineComponent} from '@vue/composition-api';
Vue.use(VueCompositionAPI);

export interface Region {
  name: string;
  key: string;
  left: number;
  top: number;
}

const RegionsMapView = defineComponent({
  components: {
    WorldMap,
  },
  setup(_, {emit}) {
    return {
      ...useMap(emit),
    };
  },
});

export default RegionsMapView;
